export enum API {
  GET_ALL_PARTNERS = '/partners?populate=*',
  COMPANIES_BY_INDUSTRY = '/industries?populate[]=companies&populate[]=companies.logo&populate[]=companies.industries&populate[]=companies.founder&populate[]=companies.founder.photo&populate[]=companies.founder.past&populate[]=companies.founder.past.logo&sort[0]=order%3Aasc',
  GET_COMPANY_BY_SLUG = '/companies?filters[slug][$eq]=:slug&populate[]=logo&populate[]=industries&populate[]=founder&populate[]=founder.photo&populate[]=founder.past&populate[]=founder.past.logo',
  CHECK_IN = '/visitors',
  VISITORS = '/visitors',
  VISITOR_BY_EMAIL = '/visitors?filters[email][$eq]=:email',
};